module.exports = __webpack_public_path__ + "static/img/cooperationBgThird.bbe67b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperationBgThird.png
// module id = DVlx
// module chunks = 1